import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeHuExtra from '@angular/common/locales/extra/hu';
import localeHu from '@angular/common/locales/hu';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import {
    LogLevel,
    provideLanguageConfig,
    provideLoadingOverlay,
    provideNavigationConfig,
    provideSharedConfig,
    provideTranslationConfig
} from '@prekog/common-ui';
import { AppConfigService } from './core/config/app-config.service';
import { routes } from './app.routes';

registerLocaleData(localeHu, 'hu-HU', localeHuExtra);

export function createAppConfig(): ApplicationConfig {
    const configService = new AppConfigService();
    const config = configService.config;

    return {
        providers: [
            provideZoneChangeDetection({ eventCoalescing: true }),
            { provide: MAT_DIALOG_DATA, useValue: {} },
            {
                provide: LOCALE_ID,
                useValue: 'hu-HU'
            },
            {
                provide: MAT_RADIO_DEFAULT_OPTIONS,
                useValue: { color: 'black' }
            },
            { provide: 'CONFIGURATOR_BASE_URL', useValue: config.backendConfiguratorUrl },
            { provide: 'API_URL', useValue: config.apiUrl },
            { provide: 'DOWNLOAD_FILE_URL', useValue: config.downloadUrl },
            { provide: 'PRODUCTION', useValue: config.production },
            { provide: 'REGENERO_BASE_URL', useValue: config.regeneroBaseUrl },
            { provide: 'AUTH_BACKEND_URL', useValue: config.backendAuthUrl },
            { provide: 'FILE_MANAGER_URL', useValue: config.backendFileManagerUrl },
            { provide: 'PUBLIC_UI_URL', useValue: config.apiUrlRegenero },
            provideHttpClient(withInterceptorsFromDi()),
            provideLoadingOverlay(),
            provideSharedConfig({
                logLevel: config.logLevel,
                enableUseCaseStatusLogs: config.enableUseCaseStatusLogs
            }),
            provideTranslationConfig({ translatedLanguages: ['hu'] }),
            provideLanguageConfig({}),
            provideNavigationConfig({}),
            provideNativeDateAdapter(),
            provideAnimationsAsync(),
            provideRouter(
                routes,
                withComponentInputBinding(),
                withInMemoryScrolling({
                    scrollPositionRestoration: 'top',
                    anchorScrolling: 'enabled'
                })
            )
        ]
    };
}
